import { render, staticRenderFns } from "./SectModal.vue?vue&type=template&id=c00a910c&scoped=true"
import script from "./SectModal.vue?vue&type=script&lang=js"
export * from "./SectModal.vue?vue&type=script&lang=js"
import style0 from "./SectModal.vue?vue&type=style&index=0&id=c00a910c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a910c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00a910c')) {
      api.createRecord('c00a910c', component.options)
    } else {
      api.reload('c00a910c', component.options)
    }
    module.hot.accept("./SectModal.vue?vue&type=template&id=c00a910c&scoped=true", function () {
      api.rerender('c00a910c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/sects/SectModal.vue"
export default component.exports